module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousSalesView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }, [_c('h2', [_vm._v("New Assignment")])])], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "objectItem"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    model: {
      value: (_vm.objectItem),
      callback: function($$v) {
        _vm.objectItem = $$v
      },
      expression: "objectItem"
    }
  }), _vm._v(" "), (!_vm.clientListData.clientName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.clientNameError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), (_vm.checkIsContract == true) ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary heght-1px md-button-color pull-right",
    on: {
      "click": function($event) {
        _vm.hireModel()
      }
    }
  }, [_vm._v("Contract")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.viewAllQuotation.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Quotation details")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Quotation List")]), _vm._v(" "), _c('th', [_vm._v("Location Details")]), _vm._v(" "), _c('th', [_vm._v("Sales Amount")]), _vm._v(" "), _c('th', [_vm._v("Approval Status")]), _vm._v(" "), _c('th', [_vm._v("Quotation Status")]), _vm._v(" "), _c('th', [_vm._v("View")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.viewAllQuotation), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n                  Quotation " + _vm._s(index + 1) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Generated On :")]), _vm._v("\n                  " + _vm._s(_vm._f("moment")(item.loginTime)) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Valid Till :")]), _vm._v("\n                  " + _vm._s(_vm._f("moment")(item.validityDate)) + "\n                ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Pickup Location :")]), _vm._v("\n                  " + _vm._s(item.fromLocation) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Factory Location :")]), _vm._v("\n                  " + _vm._s(item.StuffingLocation) + "\n                  "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Handover Location :")]), _vm._v("\n                  " + _vm._s(item.toLocation) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.quoteSalesCost))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(item.status))]), _vm._v(" "), (item.expireStatus == '1') ? _c('td', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Expired")]) : _c('td', [_vm._v("Valid till " + _vm._s(_vm._f("moment")(item.validityDate)))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      attrs: {
        "disabled": _vm.permissionStatus ? true : _vm.checkIsContract
      },
      on: {
        "click": function($event) {
          _vm.viewQuotation(item.quotationId, item.salesBookingId, item.clientId)
        }
      }
    }, [_c('md-icon', [_vm._v("visibility")])], 1)], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  })], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop1",
    attrs: {
      "md-content-html": _vm.alert1.content1,
      "md-ok-text": _vm.alert1.ok1
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e549a34","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/sales/salesBookingForm.vue
// module id = 2545
// module chunks = 0